import React, { useState } from 'react';
import { X, Box } from 'lucide-react';

export default function RoomCreationModal({ isOpen, onClose, onCreate }) {
    const [dimensions, setDimensions] = useState({
        longueur: 400,
        largeur: 300,
        hauteur: 250,
        avecPlafond: false,
        type: 'rectangle' // 'rectangle' | 'L'
    });

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onCreate(dimensions.longueur, dimensions.largeur, dimensions.hauteur, dimensions.avecPlafond, dimensions.type);
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-header">
                    <h3>Créer une nouvelle pièce</h3>
                    <button className="btn-icon" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Forme de la pièce</label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                                type="button"
                                className={`btn ${dimensions.type === 'rectangle' ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={() => setDimensions({ ...dimensions, type: 'rectangle' })}
                                style={{ flex: 1 }}
                            >
                                Rectangulaire (4 murs)
                            </button>
                            <button
                                type="button"
                                className={`btn ${dimensions.type === 'L' ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={() => setDimensions({ ...dimensions, type: 'L' })}
                                style={{ flex: 1 }}
                            >
                                En L (2 murs)
                            </button>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Longueur (cm)</label>
                        <input
                            type="number"
                            value={dimensions.longueur}
                            onChange={(e) => setDimensions({ ...dimensions, longueur: parseInt(e.target.value) || 0 })}
                            min="100"
                            required
                        />
                        <small>{dimensions.type === 'rectangle' ? 'Mur de Droite et Gauche' : 'Mur 2 (Retour)'}</small>
                    </div>

                    <div className="form-group">
                        <label>Largeur (cm)</label>
                        <input
                            type="number"
                            value={dimensions.largeur}
                            onChange={(e) => setDimensions({ ...dimensions, largeur: parseInt(e.target.value) || 0 })}
                            min="100"
                            required
                        />
                        <small>{dimensions.type === 'rectangle' ? 'Mur du Fond et Façade' : 'Mur 1 (Principal)'}</small>
                    </div>

                    <div className="form-group">
                        <label>Hauteur sous plafond (cm)</label>
                        <input
                            type="number"
                            value={dimensions.hauteur}
                            onChange={(e) => setDimensions({ ...dimensions, hauteur: parseInt(e.target.value) || 0 })}
                            min="100"
                            required
                        />
                    </div>

                    <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <input
                            type="checkbox"
                            id="avecPlafond"
                            checked={dimensions.avecPlafond}
                            onChange={(e) => setDimensions({ ...dimensions, avecPlafond: e.target.checked })}
                            style={{ width: 'auto' }}
                        />
                        <label htmlFor="avecPlafond" style={{ marginBottom: 0 }}>Inclure le plafond</label>
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Annuler
                        </button>
                        <button type="submit" className="btn btn-primary">
                            <Box size={18} style={{ marginRight: '8px' }} />
                            Générer la pièce ({dimensions.type === 'rectangle' ? '4 murs' : '2 murs'})
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
